<template>
  <section class="section plants-search-form" aria-labelledby="search-form-heading">
    <h2 class="section__title" id="search-form-heading">{{ $t('search_section_title') }}</h2>
    <p class="plants-search-form__hint">{{ $t('search_prompt') }}</p>
    <label class="visually-hidden" for="input-1">{{ $t('check_is_plant_toxic') }}</label>
    <input
      id="input-1"
      class="plants-search-form__input"
      type="search"
      autocomplete="off"
      :placeholder="$t('check_is_plant_toxic')"
      :value="q"
      @input="onQueryInput"
    >
    <div class="chip-row plants-search-form__filters">
      <div class="plants-search-form__animals">
        <button
          v-for="animal in animals"
          :key="animal.id"
          type="button"
          class="chip"
          :class="isAnimalSelected(animal.id) ? 'chip--primary' : 'chip--secondary'"
          @click="toggleAnimal(animal.id)"
        >
          {{ animalLabel(animal) }}
        </button>
      </div>
      <div class="plants-search-form__toggles">
        <button
          type="button"
          class="chip"
          :class="is_loved_plants ? 'chip--primary' : 'chip--secondary'"
          :aria-pressed="is_loved_plants ? 'true' : 'false'"
          @click="toggleLoved"
        >♥ {{ $t('filter_loved') }}</button>
        <button
          type="button"
          class="chip"
          :class="is_safe ? 'chip--primary' : 'chip--secondary'"
          :aria-pressed="is_safe ? 'true' : 'false'"
          @click="toggleSafe"
        >✓ {{ $t('filter_safe') }}</button>
      </div>
    </div>
  </section>
</template>

<script>
import { usePlantStore } from '@/stores/plant-store'
import { mapState } from 'pinia'
import { debounce } from '@/utils'

export default {
  computed: {
    ...mapState(usePlantStore, ['animals', 'lang', 'selected_animals', 'is_loved_plants', 'is_safe', 'q'])
  },
  setup () {
    usePlantStore().getAnimals()
  },
  created () {
    this.debouncedGetPlants = debounce(() => {
      const store = usePlantStore()
      store.current_page = 1
      localStorage.setItem('current_page', 1)
      store.getPlants()
    }, 1000)
    const store = usePlantStore()
    const params = new URLSearchParams(window.location.search)
    const queryFromUrl = (params.get('q') || '').trim()
    if (queryFromUrl && !store.q) {
      store.q = queryFromUrl
      localStorage.setItem('q', queryFromUrl)
    }
    store.getPlants()
  },
  methods: {
    animalLabel (animal) {
      const key = 'name_' + this.lang
      return (animal && animal[key]) || animal.name
    },
    isAnimalSelected (id) {
      return this.selected_animals.includes(id)
    },
    onQueryInput (event) {
      const store = usePlantStore()
      store.q = event.target.value
      localStorage.setItem('q', store.q)
      this.debouncedGetPlants()
    },
    toggleAnimal (id) {
      const store = usePlantStore()
      const next = store.selected_animals.includes(id)
        ? store.selected_animals.filter((item) => item !== id)
        : store.selected_animals.concat([id])
      store.selected_animals = next
      localStorage.setItem('selected_animals', JSON.stringify(next))
      this.debouncedGetPlants()
    },
    toggleLoved () {
      const store = usePlantStore()
      store.is_loved_plants = !store.is_loved_plants
      localStorage.setItem('is_loved_plants', store.is_loved_plants)
      this.debouncedGetPlants()
    },
    toggleSafe () {
      const store = usePlantStore()
      store.is_safe = !store.is_safe
      localStorage.setItem('is_safe', store.is_safe)
      this.debouncedGetPlants()
    }
  }
}
</script>
